"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var callbackPage_1 = __importDefault(require("./callbackPage"));
var login_1 = __importDefault(require("./login"));
var logout_1 = __importDefault(require("./logout"));
exports.default = {
    name: 'HootsuiteContentSourceAuth',
    routeProps: {
        path: '/authentication',
    },
    children: [callbackPage_1.default, login_1.default, logout_1.default],
};
//# sourceMappingURL=index.js.map